import React from 'react';
import { KnowledgeBaseDetail } from '../features/databases';

/**
 * DatabaseDetailPage - Admin knowledge base detail page
 */
export const DatabaseDetailPage: React.FC = () => {
  return <KnowledgeBaseDetail />;
};

export default DatabaseDetailPage;
